import * as React from 'react';

import { ILocalization } from 'bernie-l10n';

import { MultiItemStore } from 'stores/multi-item-store';

import { FCStep, FHCStep, FHStep, HCStep, MitStep, PackageType } from 'models/multi-item/multi-item-types';

import { UitkLegacyStepIndicatorExperimental } from 'uitk-react-legacy-step-indicator-experimental';
import { UitkSpacing } from 'uitk-react-spacing';

type LegacyStepIndicatorProps = {
  currentStepName: MitStep;
  multiItem: MultiItemStore;
  l10n: ILocalization;
};

export const LegacyMultiItemStepIndicator: React.FunctionComponent<LegacyStepIndicatorProps> = ({ l10n, multiItem, currentStepName }) => (
  <UitkSpacing className="all-b-padding-three all-t-padding-four">
    <div>
      <UitkLegacyStepIndicatorExperimental
        steps={getMultiItemSteps(l10n, multiItem.getPackageType())}
        currentStep={getMultiItemStepNumberFromStepName(multiItem.getPackageType(), currentStepName)}
      />
    </div>
  </UitkSpacing>
);

export function getMultiItemSteps(l10n, packageType): { text: string; icon: string }[] {
  const steps = [];

  if (packageType !== PackageType.FC)
    steps.push(
      { text: l10n.formatText(`multiItem.stepIndicator.hotel`), icon: `lob_hotels` },
      { text: l10n.formatText(`multiItem.stepIndicator.room`), icon: `bed` }
    );

  if (packageType !== PackageType.HC)
    steps.push(
      { text: l10n.formatText(`multiItem.stepIndicator.departureFlight`), icon: `lob_flights` },
      { text: l10n.formatText(`multiItem.stepIndicator.returnFlight`), icon: `lob_flights` }
    );

  if (packageType !== PackageType.FH) steps.push({ text: l10n.formatText(`multiItem.stepIndicator.car`), icon: `lob_cars` });

  return steps;
}

export function getMultiItemStepNumberFromStepName(packageType: PackageType, currentStepName: MitStep): number {
  let stepNumber: number;
  switch (packageType) {
    case PackageType.FC:
      stepNumber = FCStep[currentStepName];
      break;
    case PackageType.FH:
      stepNumber = FHStep[currentStepName];
      break;
    case PackageType.FHC:
      stepNumber = FHCStep[currentStepName];
      break;
    default:
    case PackageType.HC:
      stepNumber = HCStep[currentStepName];
      break;
  }

  return stepNumber ?? -1;
}

LegacyMultiItemStepIndicator.displayName = 'LegacyMultiItemStepIndicator';
